<script setup>
import Toast from "primevue/toast";
import { useToast } from "primevue/usetoast";
import { watch } from "vue";
import { useUserStore } from "@/store/user-store";

const toast = useToast();
const store = useUserStore();

const getToastClass = (severity) => {
  return {
    "toast-success": severity === "success",
    "toast-error": severity === "error",
    "toast-info": severity === "info",
    "toast-warning": severity === "warning",
  };
};

const getToastIcon = (severity) => {
  return {
    success: "pi pi-check-circle",
    error: "pi pi-times-circle",
    info: "pi pi-info-circle",
    warn: "pi pi-exclamation-triangle",
  }[severity];
};

watch(
  () => store.alert,
  (newMessage) => {
    if (newMessage) {
      // Ensure all values are primitives before passing to Toast
      const safeMessage = {
        summary: String(newMessage.summary || ''),
        severity: String(newMessage.severity || 'info'),
        detail: String(newMessage.detail || ''),
        life: 4000
      };
      toast.add(safeMessage);
      store.alert = null;
    }
  },
  { deep: true }
);
</script>

<template>
  <Toast>
    <template #message="slotProps">
      <div
        class="custom-toast gap-10 p-10 d-flex position-relative"
        :class="getToastClass(slotProps.message.severity)"
      >
        <i
          style="margin-top: 4px"
          :class="getToastIcon(slotProps.message.severity)"
        ></i>
        <div class="d-flex flex-direction-column gap-5">
          <span class="font-weight-500">{{ slotProps.message.summary }}</span>
          <span>{{ slotProps.message.detail }}</span>
        </div>
        <button
          class="close-btn position-absolute cursor-pointer"
          @click="() => toast.remove(slotProps.message)"
        >
          <i
            class="pi pi-times"
            :style="{ color: `var(--an-${slotProps.message.severity})` }"
          ></i>
        </button>
      </div>
    </template>
  </Toast>
</template>

<style scoped>
.custom-toast {
  width: 23rem;
  border-radius: 10px;
}

.toast-success {
  background: var(--an-success-background);
  border: 1px solid var(--an-success);
  color: var(--an-success);
}

.toast-error {
  background: var(--an-error-background);
  color: var(--an-error);
  border: 1px solid var(--an-error);
}

.toast-info {
  background: var(--an-info-background);
  color: var(--an-info);
  border: 1px solid var(--an-info);
}

.toast-warning {
  background: var(--an-warning-background);
  color: var(--an-warning);
  border: 1px solid var(--an-warning);
}

.close-btn {
  background: transparent;
  border: none;
  right: 10px;
  top: 13px;
}
</style>
